@if (!showProdConfirmation) {
<div class="main-modal">
  <div class="modal-header">
    <h3 class="modal-title">Batch Submission</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise=!minimise"></i>
      <i (click)="cancel()" class="fa fa-times"></i>
    </div>
  </div>
  <div class="modal-body" [hidden]="minimise"
    [ngStyle]="{'backgroundColor': currentTheme === 'theme-black' ? '#423d40' : 'white'}">
    <div class="options"
      [ngStyle]="{'color': currentTheme === 'theme-black' ? 'white' : 'black'}">
      <input type="radio" name="type" value="TEST" [(ngModel)]="env">
      <label>TEST</label>
      @if (canDoProdSubmit) {
<input type="radio" name="type" value="PROD" [(ngModel)]="env">
}
      @if (canDoProdSubmit) {
<label>PRODUCTION</label>
}
    </div>
  </div>
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" [disabled]="submitting" (click)="submit()">
      @if (submitting) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Submit
    </button>
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
}

@if (showProdConfirmation) {
<div class="main-modal">
  <div class="modal-header">
    <h3 class="modal-title">Confirm Production Submission</h3>
    <div class="header-actions">
      <i (click)="cancelProdConfirmation()" class="fa fa-times"></i>
    </div>
  </div>
  <div class="modal-body">
    <div class="confirmation-message">
      @if (prodConfirmationStep === 1) {
<p>Are you sure you want to submit to IRS Prod?</p>
}
      @if (prodConfirmationStep === 2) {
<p>Are you sure you want to submit to IRS Prod?</p>
}
    </div>
  </div>
  <div class="modal-footer">
    <button class="save-button" type="button" (click)="confirmProdSubmission()">Yes</button>
    <button class="cancel-button" type="button" (click)="cancelProdConfirmation()">No</button>
  </div>
</div>
}
